import { render, staticRenderFns } from "./BulkApproveRentChange.vue?vue&type=template&id=1907bb62&"
import script from "./BulkApproveRentChange.vue?vue&type=script&lang=js&"
export * from "./BulkApproveRentChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports